<template>
  <UiBaseIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    class="icon"
  >
    <path
      d="M7.746 18.671a1 1 0 0 0 0 1.44l.228.22a1 1 0 0 0 1.389 0l7.89-7.611a1 1 0 0 0 0-1.44l-7.89-7.61a1 1 0 0 0-1.389 0l-.228.22a1 1 0 0 0 0 1.439L14.663 12l-6.917 6.671Z"
      fill="#202020"
    />
  </UiBaseIcon>
</template>

<script setup lang="ts">
  import { UiBaseIcon } from '@experience/core-base-icon-ui';
</script>

<style scoped lang="scss">
  .mirror {
    transform: scaleX(-1);
  }
</style>
